/**
 *
 * @param {string} name userName
 * @returns {string} Initials
 */
const extractInitials = (name) => {
  try {
    return name
      .split(" ")
      .map((x) => x.charAt(0))
      .join("")
      .substr(0, 2)
      .toUpperCase();
  } catch (e) {
    return name.charAt(0);
  }
};

export default extractInitials;
